import { c as _c } from "react/compiler-runtime";
import React from "react";
const Loading: React.FC = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="relative mb-6"><svg className="w-12 h-12 animate-spin" viewBox="0 0 50 50"><circle className="opacity-20" cx="25" cy="25" r="20" stroke="currentColor" strokeWidth="4" fill="none" /><path className="opacity-100" fill="none" stroke="#0066CC" strokeWidth="4" strokeLinecap="round" d="M25 5 A20 20 0 0 1 45 25" /></svg></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mb-8 flex flex-col items-center justify-center py-12">{t0}<div className="flex flex-col items-center"><p className="text-[10px] font-bold text-[#6E6E73] dark:text-[#86868B] uppercase tracking-[0.2em] animate-pulse">Loading</p></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default Loading;